<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.addEventListener("DOMContentLoaded", function () {
 setTimeout(function(){ 


    const navAccount = document.querySelector('.site-nav-mobile.nav-account');
    if (navAccount) {
        const navbarItem = document.createElement('div');
        navbarItem.className = 'navbar-item';
        navbarItem.innerHTML = `
            <a href="#" class="header-region js-change-region">
                <span class="header-region-text">$(AUD)
                    <img src="//www.culturekings.com.au/cdn/shop/t/3/assets/flag-au.png?v=70499647539474713421587099664" alt="AUD" width="18" height="18">
                </span>
            </a>
        `;

        navAccount.insertAdjacentElement('afterend', navbarItem);
    }

   
   $('a.custom-button').eq(0).click(function(e){
     e.preventDefault();
  $('button#product-add-to-cart').click()
}); 
   }, 1000);
});
